export default __webpack_public_path__ + "static/media/sold_out.45f46c6b.png";